import { Injectable } from "@angular/core";
import { hd } from "./helpdesk.typings";
type IError = hd.IError;


@Injectable()
export class ErrorHandlerService {

    public handleHttpError = (err: any, status: any): IError => {
        console.log('ErrorHandlerService.handleHttpError:', err, 'Status:', status);
        return err;
    }

    public setError = (err: IError): void => {
        console.error('ErrorHandlerService.setError', err);
    }

    public clearError = (): void => {
        console.log('ErrorHandlerService.clearError');
    }
}
